import { useQuery } from '@tanstack/react-query';
import { QueryKey } from 'constants/reactQuery';
import { SectionApi } from 'api/ApiHelper';

export const useGetSectionQuery = (sectionSlug: string) =>
  useQuery({ queryKey: [QueryKey.HomeSection, sectionSlug], queryFn: () => SectionApi.getSection(sectionSlug) });
